module.exports = __webpack_public_path__ + "img/ICON4.4542884a.png";